import { Component, Input } from '@angular/core';
import { NgForOf } from '@angular/common';
import { FonteNotaInterface } from './fonte-nota.interface';

@Component({
  selector: 'app-rodape-fonte-nota',
  standalone: true,
  imports: [NgForOf],
  templateUrl: './rodape-fonte-nota.component.html',
  styleUrl: './rodape-fonte-nota.component.scss',
})
export class RodapeFonteNotaComponent {
  @Input() foteNota: FonteNotaInterface[] = [];
}
